/** Human-readable labels for submitted fields, used in delivery emails and the email fallback. */
const FIELD_LABELS: Readonly<Record<string, string>> = {
  form_type: 'Form',
  fullName: 'Full name',
  name: 'Name',
  email: 'Work email',
  company: 'Company',
  organization: 'Organization',
  role: 'Role',
  teamSize: 'Team size',
  challenge: 'What they want to improve',
  contactTime: 'Best time to reach',
  review: 'Requested materials',
  notes: 'Notes',
  message: 'Message',
  topic: 'Topic',
  intent: 'Intent',
  page_source: 'Page source',
  cta_source: 'CTA source',
  section_source: 'Section source',
  submitted_at: 'Submitted at',
  scheduling_status: 'Scheduling status',
  consent_at: 'Consent given at',
  page_url: 'Page URL',
};

/** Internal fields that never leave the browser: the honeypot and the raw consent checkbox value. */
const EXCLUDED_FIELDS = new Set(['website', 'consent']);

export const readableFieldName = (field: string): string => FIELD_LABELS[field] ?? field;

/** Non-empty fields keyed by their readable label. */
export function toReadableFields(payload: Readonly<Partial<Record<string, string>>>): Record<string, string> {
  const readable: Record<string, string> = {};
  Object.entries(payload).forEach(([key, value]) => {
    if (value && !EXCLUDED_FIELDS.has(key)) readable[readableFieldName(key)] = value;
  });
  return readable;
}
